(function ($) {
	let animContainer = document.getElementById("animated-logo");

	if (animContainer) {

		// On Dom Ready
		$(function () {

			// zoom out animation on scroll
			var controller = new ScrollMagic.Controller();
			var tween = TweenMax.to(".hero-inner", 1, {scale:0, opacity:0});

			// zoom out animation
			var scene1 = new ScrollMagic.Scene({
				triggerElement: '#page-wrapper',
				triggerHook: 0,
				duration: '100%'
			})
			.setTween(tween)
			.addTo(controller);

			// make logo appear
			var logoScene = new ScrollMagic.Scene({
				triggerElement: '#scroll-down'
			})
			.setClassToggle('.is-front-page .logo', 'scrolled')
			.addTo(controller);

			// add shadow to navbar
			var navbarScene = new ScrollMagic.Scene({
				triggerElement: '#scroll-down'
			})
			.setClassToggle('.is-front-page .navbar-desktop', 'has-shadow')
			.addTo(controller);
		});
		
	}
})(jQuery);
